



























































import { editFactory } from '@/main/pages';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { SkladoveMistoPneu } from '@/modules/ciselnik/pneu/skladoveMistoPneu';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { openSelectList } from '@/main/router/routerPath';
import { NAME as SKLAD_PNUE } from '@/modules/sklad/pneuSklad/constants';
import { ERROR } from '@/main/store/actionTypes';
import { apiProvider } from '@/modules/servis/zakazka/pneu/api';
import _ from 'lodash';

import { NAME } from './constants';
import { store } from './store/edit';
import ProvozovnaSelect from '../components/microcomponents/ProvozovnaSelect.vue';
import { editMutations } from './store/types';

export default editFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
		skladMistoPneuSelect: SkladoveMistoPneu.components.Select,
		ProvozovnaSelect,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
	},
	data() {
		return {
			visible: false,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				pracovnik: `${this.storeUri}/${editMutations.PRACOVNIK_SELECT_MAPPER}`,
				skladMisto: `${this.storeUri}/${editMutations.SKLAD_MISTO_SELECT_MAPPER}`,
				nakladoveStredisko: `${this.storeUri}/${editMutations.NAKLAD_STREDISKO_SELECT_MAPPER}`,
			};
		},
		skladPneuFilter(): object {
			return {
				SkladpneuOzn: this.SkladpneuOzn,
				VyrazenPrp: false,
			};
		},
		pneuFilter(): object {
			return {
				SkladmistopIdOd: this.SkladmistopId ? this.SkladmistopId : null,
				SkladmistopIdDo: this.SkladmistopId ? this.SkladmistopId : null,
				SkladpneuOzn: this.SkladpneuOzn ? this.SkladpneuOzn : null,
				ZakaznikId: this.IsZakaznikChk ? this.props.ZakaznikId : null,
				VozidloId: this.IsZakaznikChk ? this.props.VozidloId : null,
			};
		},
	},
	methods: {
		customValidation(): boolean {
			const pneuSkladDefined = !this.validationRules!.PneuskladId.required || !_.isNil(this.PneuskladId);
			if (!pneuSkladDefined) {
				this.showErrorAlert({
					message: `${this.Localize('cmdPneu')} ${this.LocalizeChyboveHlasky('RequiredField')}`,
					localizeMessage: false,
				});
			}
			return pneuSkladDefined;
		},
		async onSkladPneuClick() {
			await openSelectList(SKLAD_PNUE, {
				afterRowSelection: this.onPneuSelect,
				filter: this.pneuFilter,
				isFilterVisible: false,
			});
		},
		async onPneuSelect({ row }: any) {
			this.startLoading();
			const { data } = await apiProvider.getPneuSklad(row.ZAZNAM_ID);
			if (!(await this.checkZakaznikAndConfirm(data))) return;
			this.pneuSkladSelect(data);
			this.disableAddBtn = false;
			this.disableSkladPneuBtn = true;
		},
		async checkZakaznikAndConfirm(data: any): Promise<boolean> {
			let message = '';
			if (data.ZakaznikId !== this.props.ZakaznikId) {
				message = `${this.LocalizeChyboveHlasky('ZakazkapneuJinyZak')} <b>${data.ZakaznikIdText}</b>`;
			}
			if (data.VozidloId !== this.props.VozidloId) {
				message = `${this.LocalizeChyboveHlasky('ZakazkapneuJineVoz')} <b>${data.VozidloIdText}</b>`;
			}
			if (message) {
				message = `${message} </br> </br> ${this.LocalizeChyboveHlasky('ZakazkapaOdepsat')}`;
				return this.showConfirmPokracovat(message, true, true);
			}
			return true;
		},
		async onPridaniClick() {
			try {
				this.startLoading();
				if (await this.save(false)) {
					await this.default();
					this.$nextTick(() => {
						(this.mainForm as any).clearValidate();
					});
					this.refreshPreviousPage = true;
				}
			} catch (err) {
				await this.$store.dispatch(ERROR, { err }, { root: true });
			} finally {
				this.endLoading();
			}
		},
		async selected({ row }: { row: Record<string, any> }) {
			// TODO: az bude BE - mutace na prevedeni zapujcky na zakazku
		},
	},
});
